<template>
	<div class="row">
		<div class="col-xs-12 col-lg-7 detail-pane">
			<div class="card search" v-if="inSearch">
			  <div class="card-header">
				  <div class="row">
					  <div class="col">
					  	<div class="search-search col-4 input-group mb-4">
						  	<span class="input-group-text"><i class="bi-upc"></i></span>
						  	<input v-on:blur="maintainCheckoutSearchFocus" v-model="searchQuery" class="form-control form-control-sm text-end" type="text" name="checkout-search" id="checkout-search" v-on:keyup="searchPress" placeholder="Search...">
					  	</div>
					  </div>
				  </div>
				  <div class="row">
				  	<div class="search-brand col">
				  	<div class="btn-group" role="group" aria-label="Choose Search Type">
					  <input type="radio" class="btn-check search-type" value="items" name="search-type" id="search-type-items" autocomplete="off"  v-model="searchType" checked>
					  <label class="btn btn-sm btn-outline-primary" for="search-type-items">Items</label>
					
					  <input type="radio" class="btn-check search-type" value="customers" name="search-type" id="search-type-customers" autocomplete="off"  v-model="searchType">
					  <label class="btn btn-sm btn-outline-primary" for="search-type-customers">Customers</label>
					  
					  <input type="radio" class="btn-check search-type" value="transactions" name="search-type" id="search-type-transactions" autocomplete="off"  v-model="searchType">
					  <label class="btn btn-sm btn-outline-primary" for="search-type-transactions">Transactions</label>
					</div>

				  	</div>
				  </div>
			  </div>
			  <div class="card-footer text-center" v-if="loading">
				  <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
			  </div>
			  <ul class="list-group search-results search-results-items list-group-flush" v-cloak v-if="searchType == 'items'">
				  <li class="list-group-item  d-flex justify-content-start align-items-center" v-for="(item, index) in searchResultsItems">
				   	<div class="mr-4">
					   	<img class="image" v-bind:src="item.Image_URL__c">
				   	</div>
				   	<div class="flex-grow-1">
				    	<span class="item-description">{{ item.Description }}</span><br>
				    	<span class="item-sku">{{ item.StockKeepingUnit }} <span v-if="item.Serial__c">- {{ item.Serial__c}}</span></span>
				   	</div>
				   	<div class="flex-column text-right price">
					   	{{ item.Retail_Price__c | currency }}
				   	</div>	
				   	<div class="flex-column text-right">
				   		<div v-on:click="addItemToOrder" class="btn btn-lg" v-bind:data-index="index"><i class="bi-plus-square-fill"></i></div>
				   	</div>									  
				  </li>
			  </ul>
			  <ul class="list-group search-results  search-results-customers list-group-flush" v-cloak v-if="searchType == 'customers'">
				  <li class="list-group-item d-flex justify-content-start align-items-center" v-for="(customer, index) in searchResultsCustomers">
				   	<div class="flex-grow-1">
				    	<span class="customer-name">{{ customer.Name }}</span><br>
				    	<a class="customer-phone" :href="'tel:' + customer.Phone" v-if="customer.Phone">{{ customer.Phone }}</a><span v-if="customer.Phone && customer.PersonEmail"> - </span><a v-if="customer.PersonEmail" target="_blank" :href="'mailto:' + customer.PersonEmail">{{customer.PersonEmail}}</a></span>
				   	</div>
				   	<div class="flex-column text-right">
				   		<div class="btn btn-lg" :data-index="index"><i class="bi-box-arrow-up-right" title="View/Edit Customer"></i></div>
				   		<div class="btn btn-lg" :data-index="index" v-on:click="addCustomer"><i class="bi-person-plus-fill" title="Choose Customer"></i></div>
				   	</div>									  
				  </li>
			  </ul>
			  <ul class="list-group search-results  search-results-transactions list-group-flush" v-cloak v-if="searchType == 'transactions'">
				  <li class="list-group-item d-flex justify-content-start align-items-center" v-for="(transaction, index) in searchResultsTransactions">
				  	<div class="flex-grow-1">
					  		<div class="float-end text-right price">{{ transaction.Total__c | currency }}</div>
					  		{{transaction.POS_Date_Time__c | dateFromUnixtime}}
					  		{{transaction.Customer__r.Name}}
					  		<br>
					  		<ul class="transaction-item-list">
						  		<li v-for="(item, index) in transaction.Transaction_Line__r.records" class="d-flex align-items-center">
						  			<div class="sku-description" >{{item.SKU__c}} ({{item.Description__c}})</div>
						  			<div class="text-right price">{{item.Price__c | currency}}</div>
							 	</li>
					  		</ul>
				  	</div>
					<div class="flex-column text-right"><div class="btn btn-lg" @click="openTransactionDetailsPane(transaction)" :data-index="index"><i class="returns-icon" title="Return/Exchange"></i></div></div>
				  </li>
			  </ul>
			</div>
			<div class="card transaction-detail" v-if="inTransactionDetail">
				<div class="card-header">
					{{detailTransaction.POS_Date_Time__c | dateFromUnixtime }} - {{detailTransaction.Customer__r.Name}} - {{detailTransaction.Total__c | currency}} - {{detailTransaction.Receipt_Id__c | receipt }}
				</div>
				<ul class="list-group detail-transaction-items list-group-flush">
					<li v-for="(item, index) in detailTransaction.Transaction_Line__r.records" class="d-flex align-items-center">
					   	<div class="mr-4">
						   	<img class="image" v-bind:src="item.Image_URL__c">
					   	</div>
					   	<div class="flex-grow-1">
					    	<span class="item-description">{{ item.Description__c }}</span><br>
					    	<span class="item-sku">{{ item.SKU__c }} <span v-if="item.Serial__c">- {{ item.Serial__c}}</span></span>
					   	</div>
					   	<div class="flex-column text-right price">
						   	{{ item.Price__c | currency }}
					   	</div>	
					   	<div class="flex-column text-right">
					   		<div v-on:click="returnItem(index)" class="btn btn-lg" v-bind:data-index="index" title="Return Item"><i class="bi-arrow-up-right-circle-fill"></i></div>
					   	</div>
					</li>
				</ul>
				<div class="card-footer">
					<button type="button" v-on:click="closeTransactionDetailsPane" class="btn btn-sm btn-primary float-end">Back</button>
				</div>
			</div>
			<div class="card item-detail" v-if="inItemDetail">
				<div class="card-header">
					<span v-if="!detailItem.serviceItem">{{detailItem.StockKeepingUnit}} - </span>{{detailItem.Description}}
				</div>
				<div class="card-body">
					<div class="row">
						<div class="col-xs-12 detail-description d-flex align-items-center justify-content-center">
							<img v-bind:src="detailItem.Image_URL__c" class="detail-image">
							<ul class="detail-list">
								<li v-if="detailItem.Brand__c"><span class='detail-heading'>Brand:</span>{{detailItem.Brand__c}}</li>
								<li v-if="detailItem.Category__c"><span class='detail-heading'>Category:</span>{{detailItem.Category__c}}</li>
								<li v-if="detailItem.Sub_Category__c"><span class='detail-heading'>Subcategory:</span>{{detailItem.Sub_Category__c}}</li>
								<li v-if="detailItem.Sub_Category__c"><span class='detail-heading'>Style:</span>{{detailItem.Style__c}}</li>
								<li v-if="detailItem.Material__c"><span class='detail-heading'>Material:</span>{{detailItem.Material__c}}</li>
								<li v-if="detailItem.Color_Family__c"><span class='detail-heading'>Color:</span>{{detailItem.Color_Family__c}}</li>
								<li v-if="detailItem.Size__c"><span class='detail-heading'>Size:</span>{{detailItem.Size__c}}</li>
								<li v-if="detailItem.Condition__c"><span class='detail-heading'>Condition:</span>{{detailItem.Condition__c}}</li>
								<li v-if="detailItem.Sub_Category__c"><span class='detail-heading'>Serial:</span>{{detailItem.Serial__c}}</li>
							</ul>
						</div>
					</div>
					<ul class="list-group list-group-flush detail-price">
						<li class="row list-group-item d-flex justify-content-start align-items-center" v-if="!detailItem.serviceItem">
							<label for="detailFullPrice" class="col-sm-8 col-form-label">Retail Price:</label>
							<div class="col-sm-4">
								<input class="form-control text-end" id="detailFullPrice" type="text"  aria-label="full price" readonly v-bind:value="detailItem.Retail_Price__c | currency">
							</div>
						</li>
						<li class="row list-group-item d-flex justify-content-start align-items-center" v-if="detailItem.StockKeepingUnit != 'GIFT_CARD'">
							<label for="detailSalePrice" class="col-sm-8 col-form-label">Sale Price:</label>
							<div class="col-sm-4">
								<input v-on:focus="selectText" v-on:change="adjustDiscount" class="form-control text-end" id="detailSalePrice" type="text"  aria-label="sale price" v-model="detailItem.salePrice">
							</div>
						</li>
						<li class="row list-group-item d-flex justify-content-start align-items-top" v-if="detailItem.StockKeepingUnit == 'GIFT_CARD'">
							<label for="detailSalePrice" class="col-sm-4 col-form-label">Amount:</span></label>
							<div class="col-sm-8">
								<input v-on:focus="selectText" class="form-control text-end" id="detailSalePrice" type="text"  aria-label="sale price" v-model="detailItem.salePrice">
								<div class="invalid-feedback d-block" v-if="amountInvalid">
							        Amount must be greater than $0.
							    </div>
							</div>
						</li>
						<li class="row list-group-item d-flex justify-content-start align-items-center" v-if="!detailItem.serviceItem">
							<label for="detailDiscountAmount" class="col-sm-8 col-form-label">Discount:</label>
							<div class="col-sm-4">
								<div class="input-group discount-input-group" role="group" aria-label="Choose Discount Type">
								  <input type="radio" class="btn-check discount-type" value="amount" name="discount-type" id="discountTypeAmount" autocomplete="off"  v-model="detailItem.discountType" v-on:change="adjustDiscount">
								  <label class="btn btn-sm btn-outline-primary input-group-text" for="discountTypeAmount">$</label>
								  
								  <input v-on:focus="selectText" v-on:change="adjustDiscount" class="form-control text-end" id="detailDiscountAmount" type="text"  aria-label="discount" v-model="detailItem.discountAmount">
								  <input type="radio" class="btn-check discount-type" value="percent" name="discount-type" id="discountTypePercent" autocomplete="off"  v-model="detailItem.discountType" v-on:change="adjustDiscount" checked>
								  <label class="btn btn-sm btn-outline-primary input-group-text" for="discountTypePercent">%</label>
								</div>
							</div>
						</li>
						<li class="row list-group-item d-flex justify-content-start align-items-top" v-if="detailItem.StockKeepingUnit == 'GIFT_CARD'">
							<label for="detailGiftCardNumber" class="col-sm-4 col-form-label">Card Number:</label>
							<div class="col-sm-8">
								<input v-on:focus="selectText" class="form-control text-end" id="detailGiftCardNumber" type="text"  aria-label="gift card number" v-model="detailItem.cardNumber">
								<div class="invalid-feedback d-block" v-if="cardNumberInvalid">
							        Please scan or enter a card number.
							    </div>
							</div>
						</li>
						<li class="row list-group-item d-flex justify-content-start align-items-center" v-if="detailItem.StockKeepingUnit != 'GIFT_CARD'">
							<label for="detailQuantity" class="col-sm-8 col-form-label">Quantity:</label>
							<div class="col-sm-4">
								<input class="form-control text-end" id="detailQuantity" min="1" type="number"  aria-label="quantity" v-model="detailItem.quantity">
							</div>
						</li>
					</ul>
				</div>
				<div class="card-footer">
					<button type="button" v-on:click="addToCart" v-if="!editingDetailItem" class="btn btn-sm btn-primary float-end">Add to Cart</button>
					<button type="button" v-on:click="updateCart" v-if="editingDetailItem" class="btn btn-sm btn-primary float-end">Update Cart</button>
					<button type="button" v-on:click="removeFromCart" v-if="editingDetailItem" class="btn btn-sm btn-danger float-end detail-item-remove">Remove from Cart</button>
					<button type="button" class="btn btn-sm btn-secondary float-end">Manage Salesperson...</button>
					<button type="button" class="btn btn-sm btn-warning float-end" v-on:click="cancelEditItem">Cancel</button>
				</div>
			</div>
		</div>
		<div class="col-xs-12 col-lg-5 cart-pane">
			<div class="card cart">
			  <div class="card-header">Cart</div>
			  <div class="card-body">
			    <p class="card-text" v-cloak>
				    <a v-if="customer.Id" v-on:click="clearCustomer" class="btn btn-link btn-sm float-end">(Clear)</a>
				    <b>Customer:</b> {{customer.Name}}<span v-if="customer.Phone || customer.PersonEmail"><br></span>
				    <b v-if="customer.Phone">Phone:</b> <a class="customer-phone" :href="'tel:' + customer.Phone" v-if="customer.Phone">{{ customer.Phone }}</a><span v-if="customer.Phone && customer.PersonEmail"><br></span>
				    <b v-if="customer.PersonEmail">Email:</b> <a v-if="customer.PersonEmail" target="_blank" :href="'mailto:' + customer.PersonEmail">{{customer.PersonEmail}}</a>
				</p>
			  </div>
			  <ul class="list-group cart-items list-group-flush" v-cloak>
				  <li class="list-group-item disabled" v-if="returnItems.length > 0">Returns</li>
				  <li class="list-group-item  d-flex justify-content-start align-items-center" v-for="(item, index) in returnItems" :data-id="item.Id" :data-index="index" v-on:click="removeReturnItem(index)">

				   	<div class="mr-4">
					   	<img class="image" :src="item.Image_URL__c">
				   	</div>
				   	<div class="flex-grow-1 list-item-detail">
				    	<span class="item-description">{{ item.Description__c }}</span><br>
				    	<span class="item-sku" v-if="!item.serviceItem">{{ item.SKU__c }}</span>
				   	</div>
				   	<div class="flex-column text-right line-total line-return">
					   {{ (item.Price__c * -1) | currency }} <div class="quantity" v-if="item.quantity < -1">(x{{item.quantity * -1}})</div>
				   	</div>				  
				  </li>
				  <li class="list-group-item disabled" v-if="returnItems.length > 0 && items.length > 0">Sales</li>
				  <li class="list-group-item  d-flex justify-content-start align-items-center" v-bind:class="{ editing: item.editing }" v-for="(item, index) in items" :data-id="item.Id" :data-index="index" v-on:click="editCartItem">
				   	<div class="mr-4">
					   	<img class="image" :src="item.Image_URL__c">
				   	</div>
				   	<div class="flex-grow-1 list-item-detail">
				    	<span class="item-description">{{ item.Description }}</span><br>
				    	<span class="item-sku" v-if="!item.serviceItem">{{ item.StockKeepingUnit }}</span>
				   	</div>
				   	<div class="flex-column text-right line-total">
					   	<span v-if="item.discountAmount > 0" class='full-price'>{{item.Retail_Price__c | currency}}</span> {{ item.salePrice | currency }}
					   	<div v-if="item.discountAmount > 0" class="discount-description"><br>{{ item.discountMessage }}</div>
					   	<div class="quantity" v-if="item.quantity > 1">(x{{item.quantity}})</div>
				   	</div>
				  </li>
			  </ul>
			  <ul class="list-group cart-subtotals list-group-flush" v-cloak>
				  <li class="list-group-item  d-flex justify-content-start align-items-center" v-for="item in subtotals">
				   	<div class="mr-4">
					   	
				   	</div>
				   	<div class="flex-grow-1">
				    	<span class="item-description">{{ item.name }}</span>
				   	</div>
				   	<div class="flex-column text-right line-total">
					   	{{ item.amount | currency }}
				   	</div>
				  </li>
				  <li class="list-group-item grand-total d-flex justify-content-start align-items-center">
				   	<div class="mr-4">
					   	
				   	</div>
				   	<div class="flex-grow-1">
				    	<span class="item-description">Grand Total</span>
				   	</div>
				   	<div class="flex-column text-right line-total">
					   	{{ grandTotal | currency }}
				   	</div>
				  </li>
			  </ul>
			  <div class="card-footer d-flex flex-wrap">
				  <button type="button" class="btn btn-sm btn-warning" @click="clearCart">Clear Cart</button>
				  <button type="button" class="btn btn-sm btn-primary" @click="checkOut" v-cloak>
					  <span v-if="grandTotal > 0">Charge {{ grandTotal | currency }}</span>
					  <span v-if="grandTotal < 0">Refund {{ (-1 * grandTotal) | currency }}</span>
					  <span v-if="grandTotal == 0">Exchange</span>
				  </button>
				  <button type="button" class="btn btn-sm btn-secondary" @click="checkOutInvoice">Send as Invoice</button>
				  <button type="button" class="btn btn-sm btn-secondary" @click="checkOutLayaway">Layaway</button>
			  </div>
			</div>
			<div class="card checkout-extras">
				<div class="card-body d-flex flex-wrap">
					<button class="btn btn-sm btn-primary" type="button" @click="addGiftCard">Add Gift Card</button>
					<button class="btn btn-sm btn-primary" type="button" @click="addShipping">Add Shipping</button>
					<button class="btn btn-sm btn-primary" type="button" @click="addRentalFee">Add Rental Fee</button>
					<button class="btn btn-sm btn-primary" type="button" @click="addDeposit">Add Deposit</button>
					<button class="btn btn-sm btn-primary" type="button" @click="addRestockingFee">Add Restocking Fee</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Vue from 'vue';
import Vuex from 'vuex';
import accounting from 'accounting';

Vue.use(Vuex);
//import '@stripe/terminal-js';
//const StripeTerminal = await loadStripeTerminal();

/*
const terminal = StripeTerminal.create({
  onFetchConnectionToken: async () => {
    …
  }
})*/


var checkout =  {
  name: 'checkout',
  created: function(){      
     this.$nextTick(() => { if (document.getElementById("checkout-search")) document.getElementById("checkout-search").focus(); });
  },
  filters: {
	  'currency': value => {
		  return accounting.formatMoney(value);
	  },
	  'dateFromUnixtime': date => {
		  if (parseInt(date) == date) {
			  date = new Date(date * 1000);
		  } else {
			  date = new Date(Date.parse(date));
		  }
		  if (date == "Invalid Date") return "Invalid Date";
		  return new Intl.DateTimeFormat('en-US').format(date);
	  },
	  'receipt': value => {
		  if (value.indexOf("-") > -1) {
			  return "KWI " + value.split(" ")[2];
			  
		  } else {
			  return "Square #" + value.split(" ")[0];
		  }
		  return value.substring(0, 5).trim();
	  }
  },
  watch: {
	  'keepSearchBlurred': function () {
		  this.$nextTick(() => this.maintainCheckoutSearchFocus());
	  },
	  'searchType': function () {
		  this.lastSearchQuery = "";
		  this.runSearch();
	  }
  },
  methods: {
	searchPress(e) {
		if (this.searchTimeout)	clearTimeout(this.searchTimeout);
		
		this.searchTimeout = setTimeout(this.runSearch, 1000);
	},
	maintainCheckoutSearchFocus() {
		if (this.keepSearchBlurred) return true;
		
		if (!this.keepSearchBlurred) {
			if (document.getElementById("checkout-search")) document.getElementById("checkout-search").focus();
		}
	},
	runSearch() {
		switch (this.searchType) {
			case "items":
				this.searchItems();
			break;
			case "customers":
				this.searchCustomers();
			break;
			case "transactions":
				this.searchTransactions();
			break;
		}
	},
	async searchCustomers() {
		if (this.searchQuery == '' || this.searchQuery == this.lastSearchQuery) {
			return;
		}
		this.searchResultsCustomers = [];
		this.loading = true;
		this.lastSearchQuery = this.searchQuery;
		
		var customerDataQuery = "SELECT Id, Name, PersonEmail, Phone FROM Account " +
							   "WHERE (Name LIKE '" + this.searchQuery + "%' OR Phone LIKE '" + this.searchQuery + "%' " +
							   "OR PersonEmail LIKE '%" + this.searchQuery + "%') AND RecordType.DeveloperName='PersonAccount' " +
							   "ORDER BY Name LIMIT 25";
								
		
		const items = await fetch('/accounts/query?q=' + encodeURIComponent(customerDataQuery));
		const itemData = await items.json();
		this.loading = false;
		if (itemData.errorCode === undefined && itemData.records !== undefined) {
			this.searchResultsCustomers = itemData.records;
		} else {
			// TODO error
		}
	},
	async searchItems() {
		if (this.searchQuery == '' || this.searchQuery == this.lastSearchQuery) {
			return;
		}
		this.searchResultsItems = [];
		this.loading = true;
		this.lastSearchQuery = this.searchQuery;
		
		var productDataQuery = "SELECT Id, Retail_Price__c, Image_URL__c, Description, StockKeepingUnit, Serial__c, Brand__c, " +
							   "Category__c, Sub_Category__c, Style__c, Material__c, Color_Family__c, Size__c, Condition__c FROM Product2 " +
							   "WHERE StockKeepingUnit LIKE '" + this.searchQuery + "%' OR Serial__c LIKE '" + this.searchQuery + "%' " +
							   "OR Description LIKE '%" + this.searchQuery + "%' ORDER BY Image_URL__c DESC, Name LIMIT 25";
								
		
		const items = await fetch('/products/query?q=' + encodeURIComponent(productDataQuery));
		const itemData = await items.json();
		this.loading = false;
		if (itemData.errorCode === undefined && itemData.records !== undefined) {
			this.searchResultsItems = itemData.records;
		} else {
			// TODO error
		}
	},
	async searchTransactions() {
		if (this.searchQuery == '' || this.searchQuery == this.lastSearchQuery) {
			return;
		}
		this.searchResultsTransactions = [];
		this.loading = true;
		this.lastSearchQuery = this.searchQuery;
		
		var transactionQuery = "SELECT Id, Receipt_Id__c, Total__c, Customer__c,  Customer__r.Id, Customer__r.Name, Customer__r.PersonEmail, " +
							   " Customer__r.Phone, POS_Date_Time__c, (SELECT SKU__c, Description__c, Price__c, Image_URL__c, Serial__c FROM Transaction_Line__r) FROM Transaction__c " +
							   "WHERE Receipt_Id__c LIKE '%" + this.searchQuery + "%' OR (Customer__r.Name LIKE '" + this.searchQuery + "%' " +
							   "OR Customer__r.Phone LIKE '" + this.searchQuery + "%' OR Customer__r.PersonEmail LIKE '%" + this.searchQuery + "%') LIMIT 15";
								
		
		const items = await fetch('/transactions/query?q=' + encodeURIComponent(transactionQuery));
		const itemData = await items.json();
		if (itemData.errorCode === undefined && itemData.records !== undefined) {
			
			transactionQuery = "SELECT Id,  Receipt_Id__c, Total__c, Customer__c,  Customer__r.Id, Customer__r.Name, Customer__r.PersonEmail, " +
								   " Customer__r.Phone, POS_Date_Time__c, (SELECT SKU__c, Description__c, Price__c, Image_URL__c, Serial__c FROM Transaction_Line__r) FROM Transaction__c " +
								   "WHERE Id IN (SELECT Transaction__c FROM Transaction_Line__c WHERE SKU__c LIKE '%" + this.searchQuery + "%' " +
								   "OR Description__c LIKE '" + this.searchQuery + "%') ORDER BY POS_Date_Time__c DESC LIMIT 15";
									
			
			const skuItems = await fetch('/transactions/query?q=' + encodeURIComponent(transactionQuery));
			const skuItemsData = await skuItems.json();
			this.loading = false;
			
			this.searchResultsTransactions = itemData.records.concat(skuItemsData.records);
		}
	},
	error(message, severity) {
		
	},
	checkOut() {
		
	},				
	checkOutInvoice() {
		
	},				
	checkOutLayaway() {
		
	},				
	addGiftCard() {
		this.openDetailsPane({
			'StockKeepingUnit': 'GIFT_CARD',
			'Description': 'Gift Card',
			'Retail_Price__c': 0,
			'Image_URL__c': '/img/gift_card.png',
			'serviceItem': true,
			'cardNumber': ""
		});
		this.$nextTick(() => document.querySelector("#detailGiftCardNumber").focus());
	},				
	addShipping() {
		
	},				
	addRentalFee() {
		
	},				
	addDeposit() {
		
	},				
	addRestockingFee() {
		
	},
	addCustomer(e) {
		if (e.target.closest(".btn")) {
			const index = e.target.closest(".btn").dataset.index;
			if (index != undefined)	this.customer = JSON.parse(JSON.stringify(this.searchResultsCustomers[index]));
		}
		
	},
	clearCustomer() {
		this.customer = {'Name':'Guest'};
	},
	clearCart() {
		this.inItemDetail = false;
		this.inSearch = true;
		this.keepSearchBlurred = false;
		this.items = [];
		this.returnItems = [];
		this.subtotals = [];
		this.grandTotal = 0;
		this.customer = "Guest";
	},
	removeReturnItem(cartIndex) {
		this.returnItems.splice(cartIndex, 1);
					
		this.updateCartTotals();
	},
	returnItem(index) {
		var transactionLine = JSON.parse(JSON.stringify(this.detailTransaction.Transaction_Line__r.records[index]));
		transactionLine.salePrice = transactionLine.Price__c;
		transactionLine.quantity = -1;
		
		this.returnItems.push(transactionLine);
		
		this.updateCartTotals();
		this.searchQuery = "";
		this.searchResultsItems = [];
		this.closeTransactionDetailsPane();
	},
	addItemToOrder(e) {
		var targEl = e.target.closest(".btn");
		const index = targEl.dataset.index;
		
		if (index !== undefined) {
			const itemData = JSON.parse(JSON.stringify(this.searchResultsItems[index]));
			this.openDetailsPane(itemData, false);
		}
	},
	editCartItem(e) {
		if (e.target.closest("li.list-group-item")) {
			const orderItemIndex = e.target.closest("li.list-group-item").dataset.index;
			const orderItemData = JSON.parse(JSON.stringify(this.items[orderItemIndex]));
			this.items[orderItemIndex].editing = true;
			if (orderItemIndex !== undefined && this.items[orderItemIndex] !== undefined) {
				this.editingDetailItem = true;
				this.$nextTick(() => this.openDetailsPane(orderItemData, orderItemIndex));
			}
		}
		
	},
	cancelEditItem() {
		if (this.detailItem.cartIndex) {
			this.items[this.detailItem.cartIndex].editing = false;
			this.editingDetailItem = false;
		}
		this.inItemDetail = false;
		this.inSearch = true;
		this.keepSearchBlurred = false;
		this.$nextTick(() => document.getElementById("checkout-search").select());
		
	},
	openDetailsPane(productData, orderItemIndex) {
		
		if (orderItemIndex === false || orderItemIndex === undefined) {
			productData.cartAction = 'add';
			productData.cartIndex = false;
			productData.orderItem = false;
			productData.salePrice = accounting.formatMoney(productData.Retail_Price__c);
			productData.quantity = 1;
			productData.discountType = "percent";
			productData.discountAmount = accounting.formatNumber(0, 4).replace(/\.?0+$/, '');
		} else {
			productData.cartAction = 'update';
			productData.cartIndex = orderItemIndex;
			productData.orderItem = this.items[orderItemIndex]
			productData.salePrice = accounting.formatMoney(productData.orderItem.salePrice);
			productData.discountType = productData.orderItem.discountType;
			productData.discountAmount = ((productData.discountType == "percent") ? accounting.formatNumber(productData.orderItem.discountAmount, 4).replace(/\.?0+$/, '') : accounting.formatMoney(productData.orderItem.discountAmount));
			productData.quantity = productData.orderItem.quantity;

		}
		this.detailItem = productData;
		
		this.inSearch = false;
		this.keepSearchBlurred = true;
		this.inItemDetail = true;
		this.$nextTick(() => document.getElementById("detailSalePrice").focus());
	},
	openTransactionDetailsPane(transactionData) {
		this.detailTransaction = transactionData;
		this.inSearch = false;
		this.keepSearchBlurred = true;
		this.inTransactionDetail = true;
	},
	closeTransactionDetailsPane() {
		this.inTransactionDetail = false;
		this.inSearch = true;
		this.keepSearchBlurred = false;
		this.detailTransaction = {};
	},
	addToCart() {
		var productData = this.detailItem;
		
		if (productData.StockKeepingUnit == 'GIFT_CARD') {
			var invalid = false;
			
			if (productData.cardNumber == '') {
				this.cardNumberInvalid = true;
				document.querySelector("#detailGiftCardNumber").focus();
				invalid = true;
			} else {
				this.cardNumberInvalid = false;
			}
		
			if (accounting.unformat(productData.salePrice) == 0) {
				this.amountInvalid = true;
				document.querySelector("#detailSalePrice").focus();
				invalid = true;
			} else {
				this.amountInvalid = false;
			}
			
			if (invalid) return false;
			
			console.log("CONTINUING");
		}
		
		productData.discountAmount = accounting.unformat(productData.discountAmount);
		productData.salePrice = accounting.unformat(productData.salePrice);
		
		this.items.push(productData);
		
		this.updateCartTotals();
		this.searchQuery = "";
		this.searchResultsItems = [];
		this.closeDetailsPane();
		
	},
	updateCart() {
		if (this.detailItem.cartIndex !== false) {
			var productData = this.detailItem;
			
			if (productData.StockKeepingUnit == 'GIFT_CARD') {
				var invalid = false;
				
				if (productData.cardNumber == '') {
					this.cardNumberInvalid = true;
					document.querySelector("#detailGiftCardNumber").focus();
					invalid = true;
				} else {
					this.cardNumberInvalid = false;
				}
			
				if (accounting.unformat(productData.salePrice) == 0) {
					this.amountInvalid = true;
					document.querySelector("#detailSalePrice").focus();
					invalid = true;
				} else {
					this.amountInvalid = false;
				}
				
				if (invalid) return false;
			}
			
			productData.editing = false;
			productData.discountAmount = accounting.unformat(productData.discountAmount);
			productData.salePrice = accounting.unformat(productData.salePrice);
			this.items.splice(this.detailItem.cartIndex, 1, productData);
			
			this.updateCartTotals();
			this.closeDetailsPane();
		}
		
	},
	removeFromCart() {
		if (this.detailItem.cartIndex !== false) {
			this.items.splice(this.detailItem.cartIndex, 1);
						
			this.updateCartTotals();
			this.closeDetailsPane();
		}
	},
	updateCartTotals() {
		var subtotals = [];
		
		const total = this.items.concat(this.returnItems).map( i => i.salePrice * i.quantity ).reduce((a, c) => c + a, 0), tax = this.getTax(), taxAmount = total * tax[1], grandTotal = total + taxAmount;
		
		subtotals.push({name: "Subtotal", amount: accounting.formatMoney(total)});
		subtotals.push({name: tax[0] + " (" + accounting.formatNumber(tax[1]*100, 3) + "%)", amount: accounting.formatMoney(taxAmount)});
		
		this.subtotals = subtotals;
		this.grandTotal = grandTotal;
		
	},
	getTax() {
		return ["NYC Sales Tax", 0.08875];
	},
	closeDetailsPane() {
		this.inItemDetail = false;
		this.editingDetailItem = false;
		this.keepSearchBlurred = false;
		this.detailItem  = {};
		this.inSearch = true;
	},
	adjustDiscount(e) {
		if (this.detailItem.serviceItem) return false;
		if (this.adjustingDiscount) return false;
		if (e.target) {
			this.adjustingDiscount = true;
			this.$nextTick(function () {
				try {
					const basePrice = this.detailItem.Retail_Price__c;
					
					var newPrice, newDiscount;
					if (basePrice == 0) {
						this.adjustingDiscount = false;
						return;
					} else if (e.target.id == "discountTypeAmount" || e.target.id == "discountTypePercent") {
						newPrice = accounting.unformat(this.detailItem.salePrice);
						if (this.detailItem.discountType == "amount") {
							newDiscount = basePrice - newPrice;
						} else {
							newDiscount = ((basePrice - newPrice) * 100)/basePrice
						}
					} else if (e.target.id == "detailSalePrice") {
						// sale price changed
						this.detailItem.discountType = "amount";
						newPrice = accounting.unformat(this.detailItem.salePrice);
						newDiscount = basePrice - newPrice;
						
						
					} else {					
						// discount amount changed
						
						if (this.detailItem.discountType == "percent") {
							newPrice = basePrice - ((accounting.unformat(this.detailItem.discountAmount) * basePrice) / 100);
							if (newPrice < 0) {
								newPrice = 0;
								this.detailItem.discountAmount = 100;
							}
						} else {
							newPrice = basePrice - accounting.unformat(this.detailItem.discountAmount);							
							if (newPrice < 0) {
								newPrice = 0;
								this.detailItem.discountAmount = basePrice;
							}
						}
						newDiscount = accounting.unformat(this.detailItem.discountAmount);
					}
					
					// make it all look good
					
						this.detailItem.salePrice  = accounting.formatMoney(newPrice);
					
					if (this.detailItem.discountType == "percent") {
						this.detailItem.discountAmount = accounting.formatNumber(newDiscount, 4).replace(/\.?0+$/, '');
					} else {
						this.detailItem.discountAmount = accounting.formatMoney(newDiscount);
					}
					this.adjustingDiscount = false;
				} catch (ex) {
					console.log("Exception occurred adjusting discount");
					console.log(ex);
					this.adjustingDiscount = false;
				}
			});
		}
	},
	selectText(e) {
		e.target.setSelectionRange(0, e.target.value.length);
	}
  },
  data() {
	  return {
	  	keepSearchBlurred: false,
	    customer: {'Name': 'Guest'},
	    searchTimeout: false,
	    searchType: "items",
	    searchQuery: "",
	    lastSearchQuery: "",
	    adjustingDiscount: false,
	    detailItem: {},
	    detailTransaction: {},
	    inTransactionDetail: false,
	    editingDetailItem: false,
	    inItemDetail: false,
	    inSearch: true,
	    loading: false,
	    items: [],
	    returnItems: [],
	    subtotals: [],
	    grandTotal: 0.00,
	    cardNumberInvalid: false,
	    amountInvalid: false,
	    searchResultsItems: [],
	    searchResultsCustomers: [],
	    searchResultsTransactions: []
    };
  }
};

export default checkout;
</script>